var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext } from "react";
import { useAsyncUpdate } from "@iscr/xAppLib/Hooks/useAsync";
import { v4 as uuidv4 } from "uuid";
import user_model from "@iscr/models/user_model";
const Context = createContext(null);
const formatActionName = (action) => action.replace(/\W/g, " ");
export function UserActionsContext({ user, onCompleted, children }) {
    var _a;
    const actions = (_a = user.actions) !== null && _a !== void 0 ? _a : [];
    const can = useCallback((action) => (actions !== null && actions !== void 0 ? actions : []).includes(action), [actions]);
    const action = useAsyncUpdate((_a) => __awaiter(this, [_a], void 0, function* ({ type }) {
        const args = {
            uid: user.uid,
        };
        const notificationId = `user_action_${type}_${uuidv4()}`;
        const actionName = formatActionName(type);
        try {
            yield user_model.user_admin_action(type, args);
            app.trigger(app.events.SHOW_MESSAGE, actionName, "Success", "positive", notificationId);
            onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted();
        }
        catch (e) {
            app.trigger(app.events.SHOW_MESSAGE, actionName, e instanceof Error ? e.message : String(e), "negative", notificationId);
        }
    }));
    return (_jsx(Context.Provider, { value: { user, can, action: action.fn, loading: action.loading }, children: children }));
}
export function useUserActions() {
    const value = useContext(Context);
    if (value === null) {
        throw new Error("useUserActions must be used within a UserActionsContext");
    }
    return value;
}
